<script>
import options from './SpotCardGrid.options'
export default options
</script>

<template>
  <a
    :href="spotCardData.href"
    class="kb-spot-card-grid"
    :class="spotCardData.colorTheme"
    ref="linkRef"
  >
    <template v-if="!spotCardData.svgIcon">
      <div class="kb-spot-card-grid__box__decoration">
        <svg
          width="512"
          height="445"
          viewBox="0 0 512 445"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          role="presentation"
        >
          <path
            d="M-698.154 720.628C-614.642 775.767 -501.149 766.579 -427.628 693.059L103.706 162.567C312.897 -46.6237 652.06 -46.6237 861.245 162.567C1070.44 371.759 1070.44 710.921 861.245 920.107C652.054 1129.3 312.892 1129.3 103.706 920.107"
            stroke="white"
            stroke-width="130.892"
            stroke-miterlimit="10"
          />
          <path
            d="M-958.539 919.683C-1167.73 710.492 -1167.73 371.329 -958.539 162.143C-749.348 -47.0478 -410.185 -47.0478 -200.999 162.143L330.335 693.478C414.361 777.504 550.59 777.504 634.615 693.478C718.641 609.452 718.641 473.223 634.615 389.197C550.59 305.171 414.361 305.171 330.335 389.197L-200.999 919.688C-250.11 968.799 -306.376 1006.38 -366.45 1032.43"
            stroke="white"
            stroke-width="130.892"
            stroke-miterlimit="10"
          />
        </svg>
      </div>
    </template>

    <div class="kb-spot-card-grid__box__content-container">
      <template v-if="spotCardData.svgIcon">
        <div class="kb-spot-card-grid__box__icon-wrapper">
          <div
            class="kb-spot-card-grid__box__circle"
            v-html="spotCardData.svgIcon"
          ></div>
        </div>
      </template>

      <div class="kb-spot-card-grid__box__content">
        <h3 class="kb-spot-card-grid__box__title">{{ spotCardData.title }}</h3>
        <p class="kb-spot-card-grid__box__paragraph">{{ spotCardData.text }}</p>

        <template v-if="spotCardData.buttonTitle">
          <div class="kb-spot-card-grid__box__button-wrapper">
            <button
              @click="handleButtonClick"
              :class="{
                'kb-button kb-button--spot-border-color':
                  !spotCardData.buttonFill,
                'kb-button kb-button--full-color-spot': spotCardData.buttonFill
              }"
            >
              {{ spotCardData.buttonTitle }}
            </button>
          </div>
        </template>
      </div>
    </div>
  </a>
</template>
